/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuantityPerPalletViewModel } from '../../models/quantity-per-pallet-view-model';

export interface GetQuantityPerPallet$Params {
  productionOrderId: number;
}

export function getQuantityPerPallet(http: HttpClient, rootUrl: string, params: GetQuantityPerPallet$Params, context?: HttpContext): Observable<StrictHttpResponse<QuantityPerPalletViewModel>> {
  const rb = new RequestBuilder(rootUrl, getQuantityPerPallet.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuantityPerPalletViewModel>;
    })
  );
}

getQuantityPerPallet.PATH = '/api/v1/SetupParameter/GetQuantityPerPallet/{productionOrderId}';
